export default {
  name: 'lock',
  platforms: {
    lockForWeb: {
      title: 'Lock for Web',
      name: 'lock',
      description: 'Bug fixes only',
      sdk: {
        name: 'Lock',
        url: 'https://github.com/auth0/lock',
        referenceUrl: '/docs/libraries/lock',
        logo: 'auth0'
      }
    },
    lockForIOS: {
      title: 'Lock for iOS',
      name: 'lock',
      description: 'Bug fixes only',
      sdk: {
        name: 'Lock.swift',
        url: 'https://github.com/auth0/Lock.swift',
        referenceUrl: '/docs/libraries/lock-swift',
        logo: 'auth0'
      }
    },
    lockForAndroid: {
      title: 'Lock for Android',
      name: 'lock',
      description: 'Bug fixes only',
      sdk: {
        name: 'Lock.Android',
        referenceUrl: '/docs/libraries/lock-android',
        url: 'https://github.com/auth0/Lock.Android',
        logo: 'auth0'
      }
    }
  }
};
